// Données des produits de boucherie
export const products = [
  {
    id: 1,
    name: "Côte de Bœuf Premium",
    category: "Bœuf",
    price: 28.90,
    unit: "kg",
    description: "Côte de bœuf maturée 21 jours, race Charolaise. Parfaite pour vos grillades et rôtis.",
    image: "/images/real/beef-steak.jpg",
    stock: 15,
    featured: true
  },
  {
    id: 2,
    name: "Filet de Porc Fermier",
    category: "Porc",
    price: 16.50,
    unit: "kg",
    description: "Filet de porc fermier élevé en plein air. Viande tendre et savoureuse.",
    image: "/images/real/pork-meat.jpg",
    stock: 20,
    featured: false
  },
  {
    id: 3,
    name: "Gigot d'Agneau",
    category: "Agneau",
    price: 24.80,
    unit: "kg",
    description: "Gigot d'agneau de nos éleveurs locaux. Idéal pour les repas de famille.",
    image: "/images/real/lamb-leg.jpg",
    stock: 8,
    featured: true
  },
  {
    id: 4,
    name: "Poulet Fermier Entier",
    category: "Volaille",
    price: 12.90,
    unit: "kg",
    description: "Poulet fermier élevé au grain. Label Rouge, chair ferme et goûteuse.",
    image: "/images/real/chicken.jpg",
    stock: 25,
    featured: false
  },
  {
    id: 5,
    name: "Entrecôte de Bœuf",
    category: "Bœuf",
    price: 32.50,
    unit: "kg",
    description: "Entrecôte de bœuf persillée, race Limousine. Grillée à point, un délice !",
    image: "/images/real/beef-steak.jpg",
    stock: 12,
    featured: true
  },
  {
    id: 6,
    name: "Saucisses de Toulouse",
    category: "Charcuterie",
    price: 8.90,
    unit: "kg",
    description: "Saucisses de Toulouse artisanales, pur porc. Recette traditionnelle.",
    image: "/images/real/sausages.jpg",
    stock: 30,
    featured: false
  },
  {
    id: 7,
    name: "Magret de Canard",
    category: "Volaille",
    price: 22.00,
    unit: "kg",
    description: "Magret de canard du Sud-Ouest. Parfait pour un repas gastronomique.",
    image: "/images/real/duck-breast.jpg",
    stock: 10,
    featured: true
  },
  {
    id: 8,
    name: "Rôti de Veau",
    category: "Veau",
    price: 26.90,
    unit: "kg",
    description: "Rôti de veau élevé sous la mère. Viande blanche et fondante.",
    image: "/images/real/veal-roast.jpg",
    stock: 3,
    featured: false
  },
  {
    id: 9,
    name: "Côtelette d'Agneau",
    category: "Agneau",
    price: 18.50,
    unit: "kg",
    description: "Côtelettes d'agneau fraîches, parfaites pour le grill.",
    image: "/images/real/lamb-leg.jpg",
    stock: 0,
    featured: false
  },
  {
    id: 10,
    name: "Bacon Artisanal",
    category: "Charcuterie",
    price: 14.90,
    unit: "kg",
    description: "Bacon fumé artisanal, tranché à la main.",
    image: "/images/real/sausages.jpg",
    stock: 2,
    featured: false
  }
];

export const categories = [
  "Tous",
  "Bœuf",
  "Porc", 
  "Agneau",
  "Veau",
  "Volaille",
  "Charcuterie"
];